import styled from "styled-components";

export const Card = styled.div`
  max-width: 720px;
  margin: 0 auto;
  background: var(--surface-glass);
  backdrop-filter: blur(30px);
  border: 2px solid var(--border-default);
  border-radius: 24px;
  padding: 2rem;
  box-shadow: var(--shadow-md);
`;

export const Title = styled.h1`
  font-size: 1.75rem;
  font-weight: 700;
  background: linear-gradient(135deg, var(--accent-secondary) 0%, var(--accent) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0 0 0.5rem 0;
  text-align: center;
`;

export const Subtitle = styled.p`
  color: var(--text-heading);
  text-align: center;
  margin: 0 0 2rem 0;
  font-size: 0.95rem;
  line-height: 1.5;
`;

export const Field = styled.div`
  margin-bottom: 1.25rem;
`;

export const Label = styled.label`
  display: block;
  color: var(--text-heading);
  font-weight: 600;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
`;

export const Select = styled.select`
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 12px;
  border: 2px solid var(--border-subtle);
  background: var(--surface-overlay);
  color: var(--text-primary);
  font-size: 1rem;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: var(--accent);
  }
`;

export const ReadOnlyActionValue = styled.div`
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 12px;
  border: 2px solid var(--border-subtle);
  background: var(--surface-1);
  color: var(--text-primary);
  font-size: 1rem;
  box-sizing: border-box;
  cursor: default;
  user-select: none;
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 120px;
  padding: 0.75rem 1rem;
  border-radius: 12px;
  border: 2px solid var(--border-subtle);
  background: var(--surface-overlay);
  color: var(--text-primary);
  font-size: 1rem;
  resize: vertical;
  box-sizing: border-box;
  font-family: inherit;

  &::placeholder {
    color: var(--input-placeholder);
  }

  &:focus {
    outline: none;
    border-color: var(--accent);
  }
`;

export const PhotoRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: flex-end;
  margin-bottom: 0.75rem;
  padding: 0.75rem;
  background: var(--surface-glass);
  border-radius: 12px;
  border: 1px solid var(--accent-secondary-soft);
`;

export const FileInput = styled.input`
  flex: 1;
  min-width: 180px;
  color: var(--text-primary);
  font-size: 0.875rem;
`;

export const RowActions = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
`;

export const GhostButton = styled.button`
  background: var(--surface-glass);
  border: 2px solid var(--border-default);
  color: var(--accent-secondary);
  padding: 0.5rem 1rem;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.875rem;

  &:hover {
    border-color: var(--accent);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const PrimaryButton = styled.button`
  background: linear-gradient(135deg, var(--accent-soft), var(--border-subtle));
  border: 2px solid var(--accent);
  color: var(--accent-secondary);
  padding: 0.85rem 2rem;
  border-radius: 50px;
  cursor: pointer;
  font-weight: 700;
  font-size: 1rem;
  margin-top: 0.5rem;
  width: 100%;

  &:hover:not(:disabled) {
    border-color: var(--text-secondary);
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

export const ErrorText = styled.p`
  color: var(--danger);
  font-size: 0.9rem;
  margin: 0 0 1rem 0;
`;

export const FileHint = styled.p`
  color: var(--input-placeholder);
  font-size: 0.8rem;
  margin: -0.25rem 0 0.5rem 0;
`;

export const SelectedFileName = styled.span`
  flex: 1;
  min-width: 120px;
  color: var(--text-secondary);
  font-size: 0.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
